import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import Wavesurfer from 'wavesurfer.js'
import WavesurferRegions from 'wavesurfer.js/dist/plugins/regions.esm.js'
import WavesurferMinimap from 'wavesurfer.js/dist/plugins/minimap.esm.js'
import WavesurferTimeline from 'wavesurfer.js/dist/plugins/timeline.esm.js'
import PeaksWaveformHelper from 'models/audioEditor/PeaksWaveformHelper';
import AudioBufferRegionSelectorTemplate from 'text!../../../templates/audioEditor/AudioBufferRegionSelectorTemplate.html';
import ti18n from 'i18n!nls/Sequenceri18n';
import RSVP from 'rsvp';

const SELECTED_REGION_ID = "selectedRegion";
const SHOW_MINIMAP = true;
const CONTEXT_WINDOW_MS = 60000;
const MAX_PX_PER_SEC = 8000;

const REGION_HANDLE_COLOR = '#e9605d';
const REGION_OVERLAY_COLOR = 'rgba(246, 186, 184, 0.5)';
const CURSOR_COLOR = '#6327f5';
const WAVEFORM_COLOR = '#434343';
const TIMELINE_TEXT_COLOR = '#111';

const AudioBufferRegionSelectorView = Backbone.View.extend({

    initialize: function (options)
    {
        this.model = options.model;
        this.audioUniqueId = options.audioUniqueId;
        this.audioType = options.audioType;
        this.sequencerSettings = options.sequencerSettings;
        this._zoomLevel = (!this.model.endTime && !this.model.startTime) ? 1 : 4;
        this._defaultBasePxPerSec = 0;
        this._defaultMinPxPerSec = 0;
        this._defaultMaxPxPerSec = MAX_PX_PER_SEC;
        this.compiledTemlate = _.template(AudioBufferRegionSelectorTemplate);
        this._isRemoved = false;
        this._pendingZoomTimer = null;
        this._windowStartTimeMs = 0;
    },

    events: {
        "click #playRegionBtn": "onPlayRegionButtonClicked",
        "click #pauseRegionBtn": "stopPlayback",
        "click #increaseZoomBtn:not(.disabled)": "onIncreaseZoomButtonClicked",
        "click #decreaseZoomBtn:not(.disabled)": "onDecreaseZoomButtonClicked",
        "click #saveTrimBtn": "onSaveTrimButtonClicked",
    },

    /**
     * Entry point called by SelectAudioRegionPopupView.onAfterPageShow()
     * after the popup is visible and containers have dimensions.
     */
    initializeAndLoadWaveform: function ()
    {
        setTimeout((function ()
        {
            if (this._isRemoved) return;
            this.renderAudioWaveform().catch(function (error)
            {
                console.error('[WaveSurfer] Failed to load waveform:', error);
            });
        }).bind(this), 100);
    },

    playRegion: function ()
    {
        // WaveSurfer times are relative to the loaded audio source.
        // When using the local-context-window fallback, the loaded blob starts
        // at _windowStartTimeMs, so we must subtract the offset when converting
        // between full-asset times (getStartTime/getEndTime) and WaveSurfer times.
        const offset = this._windowStartTimeMs || 0;
        const regionStartSec = (this.getStartTime() - offset) / 1000;
        const regionEndSec = (this.getEndTime() - offset) / 1000;

        let currentTimeSec = this.wavesurferInstance.getCurrentTime();
        if (currentTimeSec < regionStartSec || currentTimeSec >= regionEndSec)
        {
            currentTimeSec = regionStartSec;
        }
        if (currentTimeSec >= regionStartSec && currentTimeSec <= regionEndSec)
        {
            this.wavesurferInstance.setTime(currentTimeSec);

            // Cancel any existing playback check loop
            this._playbackCheckActive = false;

            const self = this;
            this._playbackCheckActive = true;

            const checkTime = function ()
            {
                if (self._isRemoved || !self._playbackCheckActive) return;
                if (self.wavesurferInstance.getCurrentTime() >= regionEndSec)
                {
                    self._playbackCheckActive = false;
                    self.wavesurferInstance.pause();
                    self.wavesurferInstance.setTime(regionStartSec);
                } else
                {
                    requestAnimationFrame(checkTime);
                }
            };

            this.wavesurferInstance.once("play", function ()
            {
                requestAnimationFrame(checkTime);
            });

            this.wavesurferInstance.play();
        }
    },

    onPlayRegionButtonClicked: function ()
    {
        this.playRegion();
    },

    onIncreaseZoomButtonClicked: function ()
    {
        this._zoomLevel = this._zoomLevel + 1;
        this._updateZoom();
    },

    setZoomLevel: function (zoomLevel)
    {
        this._zoomLevel = zoomLevel;
        this._updateZoom();
    },

    _getMinPxPerSec: function ()
    {
        let pxPerSec = this._zoomLevel > 0 ? this._defaultBasePxPerSec + (this._zoomLevel * 100) : this._defaultBasePxPerSec + (this._zoomLevel * 40);
        if (this._zoomLevel > 5)
        {
            pxPerSec = this._defaultBasePxPerSec + (this._zoomLevel * 200);
        }
        if (this._zoomLevel > 7)
        {
            pxPerSec = this._defaultBasePxPerSec + (this._zoomLevel * 400);
        }
        if (this._zoomLevel > 10)
        {
            pxPerSec = this._defaultBasePxPerSec + (this._zoomLevel * 500);
        }
        if (pxPerSec <= this._defaultMinPxPerSec)
        {
            pxPerSec = this._defaultMinPxPerSec;
        }
        if (pxPerSec >= this._defaultMaxPxPerSec)
        {
            pxPerSec = this._defaultMaxPxPerSec;
        }
        return pxPerSec;
    },

    _updateZoom: function ()
    {
        let pxPerSec = this._getMinPxPerSec();
        if (pxPerSec <= this._defaultMinPxPerSec)
        {
            pxPerSec = this._defaultMinPxPerSec;
            this.decreaseZoomBtn$el.addClass("disabled");
        } else
        {
            this.decreaseZoomBtn$el.removeClass("disabled");
        }
        if (pxPerSec >= this._defaultMaxPxPerSec)
        {
            pxPerSec = this._defaultMaxPxPerSec;
            this.increaseZoomBtn$el.addClass("disabled");
        } else
        {
            this.increaseZoomBtn$el.removeClass("disabled");
        }
        if (this.wavesurferInstance)
        {
            $.mobile.loading("show");
            window.clearTimeout(this._pendingZoomTimer);
            this._pendingZoomTimer = window.setTimeout((function ()
            {
                if (this._isRemoved || !this.wavesurferInstance) return;
                this.wavesurferInstance.zoom(pxPerSec);
            }).bind(this), 0);
        }
    },

    onDecreaseZoomButtonClicked: function ()
    {
        this._zoomLevel = this._zoomLevel - 1;
        this._updateZoom();
    },

    onWavesurferInstanceReady: function ()
    {
        if (this._isRemoved) return;
        this.initWavesurferRegionInstance();
    },

    onWavesurferInstanceRendered: function ()
    {
        if (this._isRemoved) return;
        this.$el.removeClass("loading");
    },

    initWavesurferRegionInstance: function ()
    {
        // Adjust region times for windowed fallback offset
        const offset = this._windowStartTimeMs;
        const startTime = this.model.endTime ? (this.model.startTime - offset) / 1000 : 0;
        const endTime = this.model.endTime ? (this.model.endTime - offset) / 1000 : this.wavesurferInstance.getDuration();
        this.wsRegions = this.wavesurferInstance.registerPlugin(WavesurferRegions.create());
        this.wsRegions.addRegion({
            id: SELECTED_REGION_ID,
            start: startTime,
            end: endTime,
            resize: true,
            drag: false,
            color: REGION_OVERLAY_COLOR
        });
        this.wavesurferInstance.seekTo(startTime / this.wavesurferInstance.getDuration());
        if (SHOW_MINIMAP)
        {
            this._startTimeMinimapLabel$el.html(Utils.getInstance().formatPlaybackPositionToString(0));
            this._endTimeMinimapLabel$el.html(Utils.getInstance().formatPlaybackPositionToString(this.wavesurferInstance.getDuration()));
        }
        const region = this._getRegionWithId(SELECTED_REGION_ID);
        if (region)
        {
            region.on("update", this.onRegionUpdated.bind(this));
        }

        this.onRegionUpdated();
        this._changeStylesOfRegionHandles();
    },

    _styleRegionHandle: function (handle, side)
    {
        if (!handle) return;
        handle.style.backgroundColor = REGION_HANDLE_COLOR;
        handle.style.height = '100%';
        handle.style.width = '8px';
        handle.innerHTML = '<handle-delimiter-up style="' +
            'position: absolute; background-color: ' + REGION_HANDLE_COLOR + '; ' +
            'height: 8px; width: 16px; top: 0px; ' + side + ': 0px;' +
            '"></handle-delimiter-up>' +
            '<handle-delimiter-down style="' +
            'position: absolute; background-color: ' + REGION_HANDLE_COLOR + '; ' +
            'height: 8px; width: 16px; bottom: 0px; ' + side + ': 0px;' +
            '"></handle-delimiter-down>';
    },

    _changeStylesOfRegionHandles: function ()
    {
        const waveformContainer = this.$el.get(0).querySelector(".audio_buffer_waveform_zoomview_container > div");
        if (!waveformContainer || !waveformContainer.shadowRoot) return;

        this._styleRegionHandle(
            waveformContainer.shadowRoot.querySelector('div[part="region-handle region-handle-right"]'),
            'right'
        );
        this._styleRegionHandle(
            waveformContainer.shadowRoot.querySelector('div[part="region-handle region-handle-left"]'),
            'left'
        );
    },

    _getRegionWithId: function (regionId)
    {
        if (!this.wsRegions) return null;
        const regions = this.wsRegions.getRegions();
        for (let i = 0; i < regions.length; i++)
        {
            if (regions[i].id === regionId)
            {
                return regions[i];
            }
        }
        return null;
    },

    _onZoomCompleted: function ()
    {
        $.mobile.loading("hide");
    },

    getStartTime: function ()
    {
        const region = this._getRegionWithId(SELECTED_REGION_ID);
        return region ? this._windowStartTimeMs + (region.start * 1000) : 0;
    },

    getEndTime: function ()
    {
        const region = this._getRegionWithId(SELECTED_REGION_ID);
        return region ? this._windowStartTimeMs + (region.end * 1000) : 0;
    },

    onRegionUpdated: function ()
    {
        this._startTimeLabel$el.html(Utils.getInstance().formatPlaybackPositionToString(this.getStartTime() / 1000, true));
        this._endTimeLabel$el.html(Utils.getInstance().formatPlaybackPositionToString(this.getEndTime() / 1000, true));
    },

    onAudioStartedPlaying: function ()
    {
        this.$el.addClass("region_playing");
    },

    onAudioStoppedPlaying: function ()
    {
        this._playbackCheckActive = false;
        this.$el.removeClass("region_playing");
    },

    destroyWaveSurferInstance: function ()
    {
        this._isRemoved = true;
        this._playbackCheckActive = false;
        window.clearTimeout(this._pendingZoomTimer);
        this._resetLocalContextState();
        if (this.wavesurferInstance)
        {
            this.wavesurferInstance.destroy();
            this.wavesurferInstance = null;
        }
    },

    remove: function ()
    {
        this.destroyWaveSurferInstance();
        Backbone.View.prototype.remove.call(this);
    },

    /**
     * Load audio and render waveform.
     * Tries server-generated peaks first for windowed/large files,
     * falls back to decoding the AudioBuffer locally.
     */
    renderAudioWaveform: function ()
    {
        const audioBufferCache = this.sequencerSettings.getSequencer().getAudioBufferCache();
        const audioUrl = audioBufferCache.getCloudFrontUrlIfApplicable(this.model.audioUrl);

        this._resetLocalContextState();

        return audioBufferCache.loadAudioBufferFromUrl(audioUrl, this.audioUniqueId, this.audioType, this.sequencerSettings).then((function (audioBuffer)
        {
            if (this._isRemoved) return;

            const isWindowed = audioBuffer && audioBuffer._isWindowedAudioBuffer;

            if (isWindowed)
            {
                return this._loadWithServerPeaks(audioUrl, audioBuffer);
            } else
            {
                const peaks = PeaksWaveformHelper.generatePeaksFromAudioBuffer(audioBuffer);
                const duration = audioBuffer.duration;
                this.wavesurferInstance.load(audioUrl, peaks, duration);
            }
        }).bind(this)).catch((function (error)
        {
            this._resetLocalContextState();
            throw error;
        }).bind(this));
    },

    _resetLocalContextState: function ()
    {
        this._windowStartTimeMs = 0;
        if (this._localContextBlobUrl)
        {
            URL.revokeObjectURL(this._localContextBlobUrl);
            this._localContextBlobUrl = null;
        }
    },

    /**
     * Load waveform using server-generated peaks (for windowed/large files).
     * Falls back to decoding a local context window if server peaks unavailable.
     */
    _loadWithServerPeaks: function (audioUrl, windowedAudioBuffer)
    {
        const duration = windowedAudioBuffer.duration;
        const self = this;

        return PeaksWaveformHelper.loadServerPeaks(this.audioUniqueId, {
            shouldContinue: function () { return !self._isRemoved; }
        }).then((function (serverPeaksJson)
        {
            if (this._isRemoved) return;

            if (serverPeaksJson)
            {
                const wavesurferPeaks = PeaksWaveformHelper.convertBBCPeaksToWaveSurferPeaks(serverPeaksJson);
                this.wavesurferInstance.load(audioUrl, [wavesurferPeaks], duration);
            } else
            {
                return this._loadFromLocalContextWindow(windowedAudioBuffer);
            }
        }).bind(this));
    },

    /**
     * Fallback: decode a context window from the windowed audio buffer.
     * Creates a blob URL from the decoded buffer so waveform and playback are aligned.
     * Tracks the window offset so region coordinates map back to full-asset times.
     */
    _loadFromLocalContextWindow: function (windowedAudioBuffer)
    {
        const startMs = Math.max(0, (this.model.startTime || 0) - CONTEXT_WINDOW_MS);
        const endMs = Math.min(windowedAudioBuffer.duration * 1000, (this.model.endTime || windowedAudioBuffer.duration * 1000) + CONTEXT_WINDOW_MS);

        this._resetLocalContextState();

        return windowedAudioBuffer.getDecodedBufferForRange(startMs, endMs).then((function (decodedBuffer)
        {
            if (this._isRemoved) return;

            const peaks = PeaksWaveformHelper.generatePeaksFromAudioBuffer(decodedBuffer);
            const duration = decodedBuffer.duration;

            // Render the decoded buffer to a WAV blob URL so WaveSurfer can play it
            const offlineCtx = new OfflineAudioContext(decodedBuffer.numberOfChannels, decodedBuffer.length, decodedBuffer.sampleRate);
            const source = offlineCtx.createBufferSource();
            source.buffer = decodedBuffer;
            source.connect(offlineCtx.destination);
            source.start();
            return offlineCtx.startRendering().then((function (renderedBuffer)
            {
                if (this._isRemoved) return;

                // Convert rendered AudioBuffer to WAV blob URL for WaveSurfer playback
                const wavBlob = this._audioBufferToWavBlob(renderedBuffer);
                const blobUrl = URL.createObjectURL(wavBlob);
                this._windowStartTimeMs = startMs;
                this._localContextBlobUrl = blobUrl;
                this.wavesurferInstance.load(blobUrl, peaks, duration);
            }).bind(this));
        }).bind(this));
    },

    /**
     * Convert an AudioBuffer to a WAV Blob for use as a playable source.
     */
    _audioBufferToWavBlob: function (audioBuffer)
    {
        const numChannels = audioBuffer.numberOfChannels;
        const sampleRate = audioBuffer.sampleRate;
        const length = audioBuffer.length;
        const bytesPerSample = 2; // 16-bit PCM
        const dataSize = length * numChannels * bytesPerSample;
        const buffer = new ArrayBuffer(44 + dataSize);
        const view = new DataView(buffer);

        // WAV header
        var offset = 0;
        var writeString = function (str) { for (var i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i)); offset += str.length; };
        var writeUint32 = function (val) { view.setUint32(offset, val, true); offset += 4; };
        var writeUint16 = function (val) { view.setUint16(offset, val, true); offset += 2; };

        writeString('RIFF');
        writeUint32(36 + dataSize);
        writeString('WAVE');
        writeString('fmt ');
        writeUint32(16); // subchunk size
        writeUint16(1);  // PCM format
        writeUint16(numChannels);
        writeUint32(sampleRate);
        writeUint32(sampleRate * numChannels * bytesPerSample);
        writeUint16(numChannels * bytesPerSample);
        writeUint16(bytesPerSample * 8);
        writeString('data');
        writeUint32(dataSize);

        // Interleave channels into 16-bit PCM
        var channels = [];
        for (var ch = 0; ch < numChannels; ch++) {
            channels.push(audioBuffer.getChannelData(ch));
        }
        for (var i = 0; i < length; i++) {
            for (var c = 0; c < numChannels; c++) {
                var sample = Math.max(-1, Math.min(1, channels[c][i]));
                view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
                offset += 2;
            }
        }

        return new Blob([buffer], { type: 'audio/wav' });
    },

    initWavesurferInstance: function ()
    {
        const pluginsArray = [
            WavesurferTimeline.create({
                height: 30,
                timeInterval: 0.1,
                primaryLabelInterval: 1,
                style: {
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: TIMELINE_TEXT_COLOR,
                },
            })
        ];
        if (SHOW_MINIMAP)
        {
            pluginsArray.push(WavesurferMinimap.create({
                container: this.$el.find(".audio_buffer_waveform_overview_container").get(0),
                showRegions: true,
                cursorColor: CURSOR_COLOR,
                overlayColor: REGION_OVERLAY_COLOR
            }));
        }
        this.wavesurferInstance = Wavesurfer.create({
            container: this.$el.find(".audio_buffer_waveform_zoomview_container").get(0),
            cursorWidth: 4,
            height: 200,
            pixelRatio: 1,
            backend: "WebAudio",
            autoCenter: true,
            minPxPerSec: this._getMinPxPerSec(),
            progressColor: WAVEFORM_COLOR,
            waveColor: WAVEFORM_COLOR,
            cursorColor: CURSOR_COLOR,
            plugins: pluginsArray
        });

        this.wavesurferInstance.on('ready', this.onWavesurferInstanceReady.bind(this));
        this.wavesurferInstance.on('play', this.onAudioStartedPlaying.bind(this));
        this.wavesurferInstance.on('pause', this.onAudioStoppedPlaying.bind(this));
        this.wavesurferInstance.on('finish', this.onAudioStoppedPlaying.bind(this));
        this.wavesurferInstance.on('redrawcomplete', this.onWavesurferInstanceRendered.bind(this));
        this.wavesurferInstance.on("zoom", this._onZoomCompleted.bind(this));
    },

    onSaveTrimButtonClicked: function ()
    {
        this.trigger("saveTrim");
    },

    stopPlayback: function ()
    {
        this._playbackCheckActive = false;
        if (this.wavesurferInstance)
        {
            this.wavesurferInstance.pause();
        }
    },

    render: function ()
    {
        this.$el.html(this.compiledTemlate({ "ti18n": ti18n }));
        this.setElement(this.$el.find("section").first());
        this._startTimeLabel$el = this.$el.find(".trim_from_info");
        this._endTimeLabel$el = this.$el.find(".trim_to_info");

        this._startTimeMinimapLabel$el = this.$el.find(".minimap_start_time");
        this._endTimeMinimapLabel$el = this.$el.find(".minimap_end_time");
        this.decreaseZoomBtn$el = this.$el.find("#decreaseZoomBtn");
        this.increaseZoomBtn$el = this.$el.find("#increaseZoomBtn");
        this.saveTrimBtn$el = this.$el.find("#saveTrimBtn");
        this.$el.addClass("loading");
        this.initWavesurferInstance();

        return this;
    }

});
export default AudioBufferRegionSelectorView;
